import { render } from "./QuestionTypeSelector.vue?vue&type=template&id=4d5f9aae&scoped=true&ts=true"
import script from "./QuestionTypeSelector.vue?vue&type=script&lang=ts"
export * from "./QuestionTypeSelector.vue?vue&type=script&lang=ts"

import "./QuestionTypeSelector.vue?vue&type=style&index=0&id=4d5f9aae&lang=sass&scoped=true"

import exportComponent from "/builds/sgumanea/ciena/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4d5f9aae"]])

export default __exports__